import { render, staticRenderFns } from "./TypeSmile.vue?vue&type=template&id=2561cf53&scoped=true"
import script from "./TypeSmile.vue?vue&type=script&lang=js"
export * from "./TypeSmile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2561cf53",
  null
  
)

export default component.exports